// 9fbef606107a605d69c0edbcd8029e5d

export const pdpSubFullSizeLabels = {
  ProductDetailPage: {
    PDP_Sub: {
      lbl_full_size: 'Full Size',
    },
  },
};

export const globalAccessibilityLabels = {
  global: {
    accessibility: {
      lbl_social_twitter: 'twitter',
      lbl_social_facebook: 'facebook',
      lbl_social_pinterest: 'pinterest',
    },
  },
};
